import { api } from './http';

export interface IBuilderIcons {
	userIcons: string[];
	defaultIcons: string[];
}

export async function fetchBuilderIcons() {
	const { data } = await api.get<IBuilderIcons>('/builder-icons');
	return data;
}
